import type { Order as OrderTypes } from '@luxuryescapes/contract-svc-order'
import request from 'api/requestUtils'
import qs from 'qs'
import { orderMap } from './mappers/orderMap'

export function getOrderById(id: string) {
  const query = qs.stringify({
    include_cancellation_config: true,
  })
  return request.get<App.ApiResponse<OrderTypes.Order>>(`/api/orders/${id}?${query}`, { credentials: 'include' })
    .then(response => orderMap(response.result))
}
